
import { mapActions, mapGetters } from 'vuex'
import store from '@/common/config/store'

export default {
  
  components: {
    'component-placeholder': () => import(/* webpackChunkName: "components" */ '@/common/components/Placeholder.vue')
  },
  
  data: () => ({
    store,
    list: null,
    loading: true,
    existingList: false
  }),
  
  computed: {
    ...mapGetters([
      'beneficiariesList',
      'beneficiaryLists'
    ]),
    
    hasResult () {
      return this.beneficiariesList.beneficiaries && this.beneficiariesList.beneficiaries.length
    },
    
    listId () {
      return parseInt(this.$route.params.listId)
    },

    beneficiaryHasRib () {
      return this.beneficiariesList.beneficiaries && this.beneficiariesList.beneficiaries.some(i => i.rib)
    }
    
  },
  
  watch: {
    'store.data.user.account.uuid': function () {
      this.$router.push('/beneficiary-lists')
    },

    beneficiaryLists () {
      this.list = this.beneficiaryLists.find(list => list.id === this.listId)
    }
  },
  
  created () {
    if (this.beneficiaryLists.length && !this.beneficiaryLists.some(list => list.id === this.listId)) {
      this.$router.push('/beneficiary-lists')
    } else {
      this.list = this.beneficiaryLists.find(list => list.id === this.listId)
      this.existingList = true
    }
  },
  
  mounted () {
    if (this.existingList) {
      this.initBeneficiariesList()
    }

    this.$bus.$on('delete-success', this.onBeneficiaryDeleted)
  },
  
  destroyed () {
    this.$bus.$off('delete-success', this.onBeneficiaryDeleted)
  },
  
  methods: {
    ...mapActions([
     'getBeneficiariesList'
    ]),
    
    initBeneficiariesList () {
      this.getBeneficiariesList({
        listId: this.listId,
        params: {
          expand: true
        }
      }).then(() => {
        if (this.loading) {
          this.loading = false
        }
      })
    },

    getListComment (list) {
      return list.comment || '-'
    },

    editBeneficiary (beneficiaryId) {
      this.$router.push(`/transfers/beneficiaries-list/${this.listId}/beneficiaries/${beneficiaryId}`)
    },

    deleteBeneficiary (beneficiaryId) {
      this.showModal({
        childVue: 'delete',
        dataModel: {
          url: `${store.api.base}/beneficiaries/${beneficiaryId}`,
          title: this.$i18n.t('modal.delete.beneficiary.title'),
          content: this.$i18n.t('modal.delete.beneficiary.content')
        }
      })
    },
    
    onBeneficiaryDeleted () {
      this.showBanner('success', this.$i18n.t('banner.success.beneficiary.delete'))
      this.initBeneficiariesList()
    }
  },
}
